import { create } from "zustand"

type NavbarSearchState = {
  open: boolean
  toggle: () => void
  close: () => void
  setOpen: (open: boolean) => void
}

export const useNavbarSearchStore = create<NavbarSearchState>()((set) => ({
  open: false,
  toggle: () => set((state) => ({ open: !state.open })),
  close: () => set({ open: false }),
  setOpen: (open) => set({ open })
}))
